export default "__VITE_ASSET__BKraSaMf__"